<template>
  <section>
    <InvoiceDialog ref="invoiceDialog" />
    <qx-card :title="item.title" v-for="item in bankcardData" :key="item.key">
      <!-- 暂时屏蔽支付相关的操作 -->
      <section slot="titleRight" >
        <qx-permpisions permpisions="1004040201">
          <el-button @click="toAddBankcard(item.key)" type="primary" plain>
            <i class="iconfont">&#xe6ab;</i>新增账户
          </el-button>
        </qx-permpisions>
      </section>
      <!-- 暂时屏蔽支付相关的操作 end -->
      <p
        class="noDataTip"
        v-show="
          item.tableData &&
          item.tableData.data &&
          item.tableData.data.length === 0
        "
      >
        暂无绑定账户
      </p>
      <qx-detail-box :data="item" :colNum="1">
        <!-- 账户名 -->
        <section class="clearPa" slot="acctName" slot-scope="prop">
          <article class="left">
            {{ prop.data.acctName }}
            <span class="primary marLeft" v-show="prop.data.isDefaultAcct === 1"
              >默认账户</span
            >
          </article>
          <article class="right">
<!--            <template v-if="checkPermpisions('1004040202')">-->
<!--              <span-->
<!--                class="primary marLeft cur"-->
<!--                v-if="item.key === 'public'"-->
<!--                @click="showInvoiceDialog(prop.data)"-->
<!--                >修改票据信息</span-->
<!--              >-->
<!--            </template>-->
            <template v-if="checkPermpisions('1004040203')">
              <span
                class="primary marLeft cur"
                v-show="prop.data.isDefaultAcct !== 1 && prop.data.acctNo"
                @click="setDefault(prop.data)"
                >设为默认</span
              >
            </template>
<!--            <template v-if="checkPermpisions('1100803')">-->
<!--              <span-->
<!--                class="primary marLeft cur"-->
<!--                v-if="prop.data.acctNo"-->
<!--                @click="unbind(prop.data)"-->
<!--                >解绑</span-->
<!--              >-->
<!--            </template>-->
            <template v-if="checkPermpisions('1100802')">
              <span
                class="primary marLeft cur"
                v-if="!prop.data.acctNo"
                @click="toAddBankcard(item.key, prop.data.relSeq)"
                >绑卡</span
              >
            </template>
          </article>
        </section>
        <!-- 账户名 end -->
        <!-- 账户余额 -->
        <section slot="invoice" class="clearPa" slot-scope="prop">
          <section class="left balanceBox">
<!--            <p>-->
<!--              收款余额：-->
<!--              <span class="error">￥{{ prop.data.MBalance || 0 }}</span>-->
<!--            </p>-->
<!--            <p>-->
<!--              付款余额：-->
<!--              <span class="error">￥{{ prop.data.NBalance || 0 }}</span>-->
<!--            </p>-->
<!--            <p>-->
<!--              已付未提现：-->
<!--              <span class="error">￥{{ prop.data.SBalance || 0 }}</span>-->
<!--            </p>-->
            <p>
              <span class="error">￥{{ prop.data.balanceDouble || 0 }}</span>
            </p>

          </section>
          <!-- <section class="right" v-if="item.key === 'public'">
            <span class="primary cur" @click="showInvoiceDialog(prop.data)">修改票据信息</span>
          </section>-->
        </section>
        <!-- 账户余额 end -->
      </qx-detail-box>
    </qx-card>
  </section>
</template>

<script>
import {
  companyBankcardList,
} from 'api/getPay';
import {
  setDefaultBankcard,
  unbindBankcard,
} from 'api';
import InvoiceDialog from './invoiceDialog';
export default {
  components: {
    InvoiceDialog,
  },
  data () {
    return {
      bankcardData: {
        publicBankcard: {
          title: '对公账户',
          key: 'public',
          label: '银行账户',
          type: 'array',
          tableData: {
            title: [
              {
                prop: 'acctName',
                label: '账户名称',
                slot: true,
              },
              {
                prop: 'acctNo',
                label: '银行卡号',
              },
              {
                prop: 'bankName',
                label: '开户银行',
              },
              {
                prop: 'invoice',
                label: '账户余额',
                slot: true,
              },
            ],
            data: [],
            approveData: [],
          },
        },
        privateBankcard: {
          title: '对私账户',
          key: 'private',
          label: '银行账户',
          type: 'array',
          tableData: {
            title: [
              {
                prop: 'acctName',
                label: '账户名称',
                slot: true,
              },
              {
                prop: 'acctNo',
                label: '银行卡号',
              },
              {
                prop: 'bankName',
                label: '开户银行',
              },
              {
                prop: 'invoice',
                label: '账户余额',
                slot: true,
              },
            ],
            data: {

            },
            approveData: {

            },
          },
        },
      },
    };
  },
  methods: {
    showInvoiceDialog (item) {
      this.$refs.invoiceDialog.show(item);
    },
    toAddBankcard (type, id) {
      this.jump({
        label: `${id ? '修改' : '新增'}账户`,
        url: `/manage/other/bankcard/edit?userId=${this.adminUser}&type=${type}&id=${id || ''}`,
        full: true,
      });
    },
    async setDefault (item) { // 设置默认
      const confirmRes = await this.$confirm('是否确认设置该卡为默认卡', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await setDefaultBankcard({
          relSeq: item.relSeq,
          busiId: 1315,
          busiCode: 400000,
          userType: 6,
        });
        if (!res.failed) {
          this.$message.success('设置成功');
          this.getData();
        }
      }
    },
    async unbind (item) { // 解绑
      const confirmRes = await this.$confirm('是否确认解绑该卡', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).catch(() => { // 取消删除
      });
      if (confirmRes === 'confirm') {
        const res = await unbindBankcard({
          relSeq: item.relSeq,
          busiId: 1315,
          logCode: 400000,
        });
        if (!res.failed) {
          this.$message.success('解绑成功');
          this.getData();
        }
      }
    },
    async getData () {
      const res = await companyBankcardList({
        userId: this.$route.query.userId,
        userType: 2,
        showMoney: 'true',
      });
      this.adminUser = res.adminUser;
      this.bankcardData.publicBankcard.tableData.data = res.allPubAcct;
      this.bankcardData.privateBankcard.tableData.data = res.allPriAcct;
    },
  },
  created () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
.noDataTip {
  text-align: center;
  font-size: 14px;
  color: #999;
  height: 16px;
  line-height: 16px;
}
.marLeft {
  margin-left: 8px;
}
.balanceBox {
  line-height: 24px;
  padding: 16px 0;
}
</style>
